Ext.define('SA.view.EditableText', {
    alias: 'widget.editable-text',
    extend: 'Ext.Component',

    baseCls: 'sa-editable-text',
    childEls: ['textArea'],
    renderTpl: '<textarea id="{id}-textArea" class="{baseCls}-text"></textarea>',

    text: '',

    afterRender() {
        this.callParent();

        this.refresh();
    },

    initEvents() {
        this.callParent();

        this.textArea.on('blur', this.onBlur, this);
        this.textArea.on('change', this.onChange, this);
        this.textArea.on('focus', this.onFocus, this);
        this.textArea.on('input', this.onInput, this);
        this.textArea.on('keydown', this.onKeyDown, this);
    },

    onBlur() {
        this.removeCls('sa-editable-text-focused');
    },

    onChange() {
        this.fireEvent('change', this.text);
    },

    onFocus() {
        this.addCls('sa-editable-text-focused');
    },

    onInput() {
        this.text = this.textArea.getValue();

        this.resize();

        this.fireEvent('input', this.text);
    },

    onKeyDown(ev) {
        if (ev.getKey() === ev.ENTER) {
            this.textArea.blur();

            ev.preventDefault();
        }
    },

    onResize() {
        this.callParent(arguments);

        this.resize();
    },

    refresh() {
        if (!this.rendered) {
            return;
        }

        this.textArea.dom.maxLength = this.maxLength;
        this.textArea.dom.value = this.text;

        this.resize();
    },

    resize() {
        this.textArea.setHeight(0);

        this.textArea.setHeight(this.textArea.dom.scrollHeight);
    },

    setText(text) {
        this.text = text;

        this.refresh();
    }
});